// extracted by mini-css-extract-plugin
export default {"authButtonsWrapper":"AuthWithSocialNetworks_authButtonsWrapper__gNO37","authButton":"AuthWithSocialNetworks_authButton__5hf2l"};